import styled from "styled-components";
import { P, MainWrapper } from "@/lib/styles";
import { pageTop, pageBottom } from "@/lib/styles/helpers";

export const WishListContainer = styled(MainWrapper)`
  ${pageTop};
  ${pageBottom};

  display: flex;
`;
interface WishListWrapper {
  showWishList?: boolean;
}

export const WishListWrapper = styled.div<WishListWrapper>`
  position: fixed;
  right: ${(props) => (props.showWishList ? 0 : -100)}%;
  top: 4.5rem;
  width: 100%;
  height: 100%;
  padding: 40px 16px;
  box-sizing: border-box;
  background-color: ${({ theme }) => theme.colors.backgroundGrey};
  transition: right 0.4s ease;
  z-index: 3;

  * {
    box-sizing: border-box;
  }

  ${({ theme }) => theme.mediaQueries.tablet} {
    width: 493px;
    min-width: 493px;
    top: 0;
    padding: 40px 22px;
  }

  ${({ theme }) => theme.mediaQueries.laptop} {
    width: 352px;
    min-width: 352px;
    padding: 40px 16px;
    position: relative;
    right: 0;
  }

  ${({ theme }) => theme.mediaQueries.desktop} {
    width: 493px;
    min-width: 493px;
    padding: 40px 22px;
  }
`;


export const FormWrapper = styled.div`
  padding-top: 0.5rem;

  ${({ theme }) => theme.mediaQueries.tablet} {
    padding-top: 0rem;
  }

  ${({ theme }) => theme.mediaQueries.laptop} {
    padding-top: 1.5rem;
    padding-right: 1.5rem;
  }
`;

export const WSProductsTitle = styled.div`
  font-size: 20px;
  line-height: 24px;
  font-weight: 400;
  margin-bottom: 9px;
  font-family: ${({ theme }) => theme.fontFamilies.secondary};
  display: flex;
  justify-content: space-between;
  text-transform: uppercase;
`;

export const WSCloseButton = styled.div`
  background-color: white;
  cursor: pointer;
  height: 24px;
  padding: 3px;
  width: 24px;
  display: flex; // avoid weird space above svg

  ${({ theme }) => theme.mediaQueries.laptop} {
    display: none;
  }
`;

export const WSToggleLabelWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  align-content: flex-start;
  flex-wrap: wrap;
  margin-top: 25px;

  p {
    margin-bottom: 32px;
  }

  ${({ theme }) => theme.mediaQueries.tablet} {
    flex-direction: row;
    justify-content: space-between;
  }

  ${({ theme }) => theme.mediaQueries.laptop} {
    align-items: center;
    p {
      margin-bottom: 0;
    }
  }
`;

export const WSToggleLabel = styled.div`
  font-size: 1.25rem;
  line-height: 1.2;
  font-weight: 400;
  color: ${({ theme }) => theme.colors.red};
  cursor: pointer;
  ${({ theme }) => theme.mediaQueries.tablet} {
    padding: 1rem 0;
  }
  ${({ theme }) => theme.mediaQueries.laptop} {
    display: none;
  }
`;

export const Divider = styled.hr`
  margin-bottom: 40px;
  margin-top: 40px;
`;

export const WSMobileLayer = styled.div`
  background: ${({ theme }) => theme.colors.black};
  opacity: 0.4;
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  display: none;
  z-index: 2;

  ${({ theme }) => theme.mediaQueries.tablet} {
    display: block;
  }

  ${({ theme }) => theme.mediaQueries.laptop} {
    display: none;
  }
`;

export const Subtitle = styled(P)`
  background-color: ${({ theme }) => theme.colors.white};
  ${({ theme }) => theme.mediaQueries.tablet} {
    padding: 1rem 0;
  }
`;
